module.exports = __webpack_public_path__ + "img/dickpic.b6a04694.png";